// IMPORTS
// Modules
import { Outlet } from 'react-router-dom';
// OHS
import OHSApp from './../../onehivesystems/js/OHSApp';
// Assets
import './Settings.scss';


// COMPONENT
export default function Settings (props) {
   // States and Variables
   const navigation = [
      {
         title: "Components",
         links: [
            {
               title: "Profile",
               link: "/profile",
            },
            {
               title: "Application Settings",
               link: "/settings",
            }
         ]
      },
      {
         title: "Tools",
         links: [
            {
               title: "User Accounts",
               link: "/useraccounts"
            },
            {
               title: "Audit Logs",
               link: "/auditlogs"
            },
            {
               title: "Backup/Restore",
               link: "/backuprestore"
            }
         ]
      }
   ]

   // Component
   return (
      <OHSApp onehive={props.onehive} navigation={navigation}>
         <Outlet />
      </OHSApp>
   );
}